import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReserveCheckDialogComponent } from 'shared/dialogs/reserve-check-dialog/reserve-check-dialog.component';
import { SharedModule } from 'shared/shared.module';

@NgModule({
  declarations: [
    ReserveCheckDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    ReserveCheckDialogComponent,
  ],
})
export class ReserveCheckDialogModule {
}
